import React from 'react'
import { StackLayout, Card, CardBody, CardFooter, GridLayout, GridLayoutItem } from '@progress/kendo-react-layout'
import { Button, ButtonGroup } from '@progress/kendo-react-buttons'

import { Window } from '@progress/kendo-react-dialogs'

import AuthInput from './AuthInput'

import './Auth.css'

export default function AuthSearchResultList() {
  const [showMaintenanceDialog, setShowMaintenanceDialog] = React.useState(false)

  const toggleMaintenanceDialog = () => {
    setShowMaintenanceDialog(!showMaintenanceDialog)
  }

  return (
    <StackLayout orientation="vertical" gap={5}>
      <Card orientation="horizontal">
        <CardBody>
          <GridLayout style={{ marginTop: 20 }}>
            <GridLayout style={{ marginTop: 20 }}></GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '120px' }}>
              <span className="span-font-layout">A会社</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '400px' }}>
              <span className="span-font-layout">調達本部 第一調達</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '170px' }}>
              <span className="span-font-layout">建材部担当者</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-auth-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout style={{ marginTop: 20 }}>
            <GridLayout style={{ marginTop: 20 }}></GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '120px' }}>
              <span className="span-font-layout">B会社</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '400px' }}>
              <span className="span-font-layout">B会社調達部</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '170px' }}>
              <span className="span-font-layout">建材部担当者</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-auth-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout style={{ marginTop: 20 }}>
            <GridLayout style={{ marginTop: 20 }}></GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '120px' }}>
              <span className="span-font-layout">A会社</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '400px' }}>
              <span className="span-font-layout">調達本部 第一調達</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '170px' }}>
              <span className="span-font-layout">建材部担当者</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-auth-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout style={{ marginTop: 20 }}>
            <GridLayout style={{ marginTop: 20 }}></GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '120px' }}>
              <span className="span-font-layout">B会社</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '400px' }}>
              <span className="span-font-layout">B会社調達部</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '170px' }}>
              <span className="span-font-layout">建材部担当者</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-auth-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout style={{ marginTop: 20 }}>
            <GridLayout style={{ marginTop: 20 }}></GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '120px' }}>
              <span className="span-font-layout">A会社</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '400px' }}>
              <span className="span-font-layout">調達本部 第一調達</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '170px' }}>
              <span className="span-font-layout">建材部担当者</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-auth-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout style={{ marginTop: 20 }}>
            <GridLayout style={{ marginTop: 20 }}></GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '120px' }}>
              <span className="span-font-layout">B会社</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '400px' }}>
              <span className="span-font-layout">B会社調達部</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '170px' }}>
              <span className="span-font-layout">建材部担当者</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-auth-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout style={{ marginTop: 20 }}>
            <GridLayout style={{ marginTop: 20 }}></GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '120px' }}>
              <span className="span-font-layout">A会社</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '400px' }}>
              <span className="span-font-layout">調達本部 第一調達</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '170px' }}>
              <span className="span-font-layout">建材部担当者</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-auth-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout style={{ marginTop: 20 }}>
            <GridLayout style={{ marginTop: 20 }}></GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '120px' }}>
              <span className="span-font-layout">B会社</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '400px' }}>
              <span className="span-font-layout">B会社調達部</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '170px' }}>
              <span className="span-font-layout">建材部担当者</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-auth-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout style={{ marginTop: 20 }}>
            <GridLayout style={{ marginTop: 20 }}></GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '120px' }}>
              <span className="span-font-layout">A会社</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '400px' }}>
              <span className="span-font-layout">調達本部 第一調達</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '170px' }}>
              <span className="span-font-layout">建材部担当者</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-auth-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout style={{ marginTop: 20 }}>
            <GridLayout style={{ marginTop: 20 }}></GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '120px' }}>
              <span className="span-font-layout">B会社</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '400px' }}>
              <span className="span-font-layout">B会社調達部</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '170px' }}>
              <span className="span-font-layout">建材部担当者</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-auth-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout style={{ marginTop: 20 }}>
            <GridLayout style={{ marginTop: 20 }}></GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '120px' }}>
              <span className="span-font-layout">A会社</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '400px' }}>
              <span className="span-font-layout">調達本部 第一調達</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '170px' }}>
              <span className="span-font-layout">建材部担当者</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-auth-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout style={{ marginTop: 20 }}>
            <GridLayout style={{ marginTop: 20 }}></GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '120px' }}>
              <span className="span-font-layout">B会社</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '400px' }}>
              <span className="span-font-layout">B会社調達部</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '170px' }}>
              <span className="span-font-layout">建材部担当者</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-auth-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      {showMaintenanceDialog && (
        <Window title={'権限マスタメンテナンス　編集'} onClose={toggleMaintenanceDialog} initialWidth={1200} initialHeight={450} modal>
          <AuthInput />
          <div
            style={{
              marginTop: '10px',
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          ></div>
        </Window>
      )}
    </StackLayout>
  )
}
